export default __webpack_public_path__ + "static/media/file-excel.65e534bd.svg";